import React, { useState } from 'react';
import { DragonDropWrapper } from '../../../../../shared/DragonDrop/DragonDrop';
import AudioComponent from '../../body/AudioComponent';
import PDFdownloadButton from '../../body/PDFdownloadButton';
import PopUp from '../../body/PopUp';

const data = {
  DragonDrop: {
    type: 'bench',
    ptype: 'start',
    title: 'See if you can identify if the parent is using a reward or bribe.',
    options: {
      'option-1': {
        id: 'option-1',
        ptype: 'rewards',
        content:
          'If you stay in the shopping cart while we shop, when we are finished, you can pick out a treat.',
      },
      'option-2': {
        id: 'option-2',
        ptype: 'rewards',
        content:
          'I need to answer this phone call, if you play quietly while I’m on the phone, we can play for 10 minutes.',
      },
      'option-3': {
        id: 'option-3',
        ptype: 'bribes',
        content:
          'We have a lot to do today and I need you to be really good. So, if I give you a cookie, do you promise to be really good all day?',
      },
      'option-4': {
        id: 'option-4',
        ptype: 'bribes',
        content:
          'If I give you tablet time now, will you promise to help clean up your toys before bed?',
      },
    },
    columns: {
      'column-1': {
        id: 'column-1',
        title: 'Start',
        optionIds: ['option-1', 'option-2', 'option-3', 'option-4'], // All options start here
      },
      'column-2': {
        id: 'column-2',
        title: 'Rewards',
        optionIds: [], // Empty initially
      },
      'column-3': {
        id: 'column-3',
        title: 'Bribes',
        optionIds: [], // Empty initially
      },
    },
    columnOrder: ['column-1', 'column-2', 'column-3'], // Order of columns
    showErrorMessage: false, // Optional flag for error handling
  },
};

const RewardsActivity = () => {
  const [showPopUp, setShowPopUp] = useState(false);

  const handleSortComplete = () => {
    // Trigger the pop-up when sorting is complete
    setShowPopUp(true);
  };

  return (
    <div className='rewards-activity'>
      <h1 className='text-2xl font-bold mb-4 mt-0'>{data.DragonDrop.title}</h1>
      <DragonDropWrapper content={data.DragonDrop} />
      {showPopUp && (
        <PopUp onClose={() => setShowPopUp(false)}>
          <p>
            Rewards are more likely to encourage behavior a parent wants from
            their child!
          </p>
        </PopUp>
      )}
    </div>
  );
};

export default RewardsActivity;
